// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
const focus: Styleguide["focus"] = {
    offset: "1",
    color: "#9549F7",
    width: "2px",
};
/* Store Custom Code - End */

export default focus;
